// src/components/Register.js
import React, { useState, useEffect, useRef } from 'react'
import Header from './Header'
import '../styles/Register.css'
import '../styles/Transport.css'
// Import icons from react-icons
import { FaInfoCircle, FaEye, FaEyeSlash, FaUpload } from 'react-icons/fa'
import axios from 'axios'
import { T } from './Translation'
import { useLanguage } from '../context/LanguageContext'
import { translations } from '../translations/translations'
import PayMe3DSCheckout from './Payme/PayMe3DSCheckout'
// Define BASE_URL for API requests
const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api'
  const saleInfo = {
    // --- Backend API Fields ---
    seller_payme_id: process.env.REACT_APP_PAYME_SELLER_ID,
    sale_price: 500,
    currency: "ILS",
    product_name: "Shirt",
    // sale_type: "sale",
    // sale_callback_url: "https://your-domain.com/payment/3ds-callback", // Where 3DS sends result
    // --- Payer/Buyer Details ---
    payerFirstName: "John",
    payerLastName: "Doe",
    payerEmail: "john.doe@example.com",
    payerPhone: "+972501234567",
    // --- Tokenization Details (must match sale_price/currency) ---
    total: {
      amount: { value: '5.00', currency: 'ILS' },
      label: 'Shirt Purchase'
    }
  };
// Component for input with tooltip
const InputWithTooltip = ({
  label,
  type,
  placeholder,
  value,
  onChange,
  tooltip,
  prefix,
  min,
  max,
  translationKey,
  tooltipKey,
}) => {
  const [isTooltipVisible, setIsTooltipVisible] = useState(false)

  const toggleTooltip = () => {
    setIsTooltipVisible(!isTooltipVisible)
  }

  return (
    <div className="input-tooltip-wrapper">
      <div className="label-tooltip">
        {prefix ? (
          <div className="input-with-prefix">
            <span className="input-prefix">{prefix}</span>
            <input
              type={type}
              placeholder={
                translationKey ? <T k={translationKey} /> : placeholder
              }
              value={value}
              onChange={onChange}
              aria-label={translationKey ? <T k={translationKey} /> : label}
              className="input-with-prefix-field"
              min={min}
              max={max}
            />
          </div>
        ) : (
          <input
            type={type}
            placeholder={
              translationKey ? <T k={translationKey} /> : placeholder
            }
            value={value}
            onChange={onChange}
            aria-label={translationKey ? <T k={translationKey} /> : label}
            min={min}
            max={max}
          />
        )}
        <div className="tooltip-container">
          <FaInfoCircle className="info-icon" onClick={toggleTooltip} />
          <span className={`tooltip-text ${isTooltipVisible ? 'visible' : ''}`}>
            {tooltipKey ? <T k={tooltipKey} /> : tooltip}
          </span>
        </div>
      </div>
    </div>
  )
}

// Component for textarea with tooltip and label
const TextareaWithTooltip = ({
  label,
  placeholder,
  value,
  onChange,
  tooltip,
}) => {
  const [isTooltipVisible, setIsTooltipVisible] = useState(false)

  const toggleTooltip = () => {
    setIsTooltipVisible(!isTooltipVisible)
  }

  return (
    <div className="message-input-container">
      <label className="input-label">{label}</label>
      <div className="input-tooltip-wrapper">
        <div className="label-tooltip">
          <textarea
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            aria-label={label}
          />
          <div className="tooltip-container">
            <FaInfoCircle className="info-icon" onClick={toggleTooltip} />
            <span
              className={`tooltip-text ${isTooltipVisible ? 'visible' : ''}`}
            >
              {tooltip}
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

// Verification code input component
const VerificationCodeInput = ({ length = 6, onComplete }) => {
  const [code, setCode] = useState(Array(length).fill(''))
  const inputs = useRef([])

  const handleChange = (e, index) => {
    const value = e.target.value
    // Only allow numeric input
    if (/[^0-9]/.test(value)) return

    // Update the code array with the new value
    const newCode = [...code]
    newCode[index] = value.substring(0, 1)
    setCode(newCode)

    // Build the complete code
    const completeCode = newCode.join('')

    // If we have a digit and it's not the last input, focus next input
    if (value && index < length - 1) {
      inputs.current[index + 1].focus()
    }

    // If we've filled all inputs, trigger the onComplete callback
    if (completeCode.length === length) {
      onComplete(completeCode)
    }
  }

  const handleKeyDown = (e, index) => {
    // If backspace is pressed and current input is empty, focus previous input
    if (e.key === 'Backspace' && !code[index] && index > 0) {
      inputs.current[index - 1].focus()
    }
  }

  const handlePaste = (e) => {
    e.preventDefault()
    const pastedData = e.clipboardData.getData('text/plain').trim()
    if (!/^\d+$/.test(pastedData)) return // Only allow numeric pastes

    const newCode = [...code]
    for (let i = 0; i < Math.min(length, pastedData.length); i++) {
      newCode[i] = pastedData[i]
    }
    setCode(newCode)

    // Focus the appropriate input box after paste
    const focusIndex = Math.min(length - 1, pastedData.length)
    inputs.current[focusIndex].focus()

    // If we've filled all inputs with the paste, trigger onComplete
    if (pastedData.length >= length) {
      onComplete(pastedData.substring(0, length))
    }
  }

  return (
    <div className="verification-code-container">
      {code.map((digit, index) => (
        <input
          key={index}
          type="text"
          maxLength={1}
          value={digit}
          onChange={(e) => handleChange(e, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          onPaste={index === 0 ? handlePaste : undefined}
          ref={(el) => (inputs.current[index] = el)}
          className="verification-code-input"
          autoFocus={index === 0}
        />
      ))}
    </div>
  )
}

function Register() {
  // Add navigation hook
  const { language } = useLanguage()
  const latest = useRef({}) // never triggers re-renders
  useEffect(() => {
    latest.current = {
      step,
      wifeName,
      husbandName,
      email,
      phone,
      eventType,
      mapLink,
      eventDate,
      eventTime,
      bitLink,
      payboxLink,
      organizeTransport,
      transportStops,
      paymentMethod,
      username,
      password,
      confirmPassword,
      rsvpText,
      tomorrowMessage,
      rsvpTextSecond,
      afterWeddingText,
    }
  }) // runs after every render

  // Keep track of which step we're on

  // Form fields
  const draft = (() => {
    try {
      const raw = localStorage.getItem('wizard-draft')
      return raw ? JSON.parse(raw) : {}
    } catch {
      return {}
    }
  })()

  // 2️⃣ initialise each piece of state with the draft’s value or a default
  const [step, setStep] = useState(draft.step || 1)
  const [wifeName, setWifeName] = useState(draft.wifeName || '')
  const [husbandName, setHusbandName] = useState(draft.husbandName || '')
  const [email, setEmail] = useState(draft.email || '')
  const [phone, setPhone] = useState(draft.phone || '')
  const [eventType, setEventType] = useState(draft.eventType || 'Wedding')
  const [mapLink, setMapLink] = useState(draft.mapLink || '')
  const [eventDate, setEventDate] = useState(draft.eventDate || '')
  const [eventTime, setEventTime] = useState(draft.eventTime || '')
  const [bitLink, setBitLink] = useState(draft.bitLink || '')
  const [payboxLink, setPayboxLink] = useState(draft.payboxLink || '')
  const [organizeTransport, setOrganizeTransport] = useState(
    draft.organizeTransport ?? false
  )
  const [transportStops, setTransportStops] = useState(
    draft.transportStops || []
  )
  const [paymentMethod, setPaymentMethod] = useState(draft.paymentMethod || '')
  const [username, setUsername] = useState(draft.username || '')
  const [password, setPassword] = useState(draft.password || '')
  const [confirmPassword, setConfirmPassword] = useState(
    draft.confirmPassword || ''
  )

  const [invitationImage, setInvitationImage] = useState(null)

  const [newStop, setNewStop] = useState('')

  const [showPassword, setShowPassword] = useState(false)
  /* ----- NEW ----- */
  const [rsvpText, setRsvpText] = useState(
    draft.rsvpText || 'היי! נשמח לאשר את הגעתכם לחתונתנו דרך הקישור: '
  )
  const [tomorrowMessage, setTomorrowMessage] = useState(
    draft.tomorrowMessage || 'היי! רק רצינו להזכיר לכם את החתונה מחר. נשמח לראותכם!'
  )
  const [rsvpTextSecond, setRsvpTextSecond] = useState(
    draft.rsvpTextSecond || 'תזכורת אחרונה! אנא אשרו הגעה בלחיצה על הקישור: '
  )
  const [afterWeddingText, setAfterWeddingText] = useState(
    draft.afterWeddingText ||
      'תודה שחגגתם איתנו! הייתם חלק בלתי נשכח מהיום המיוחד שלנו ❤️'
  )

  // Additional state variables
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [imageUploadError, setImageUploadError] = useState('')
  const [couponCode, setCouponCode] = useState('')
  const [couponValid, setCouponValid] = useState(false)
  const [couponLoading, setCouponLoading] = useState(false)
  const [couponError, setCouponError] = useState('')


  // ----new----
  // Payment iframe state 
  const [paymentUrl, setPaymentUrl] = useState('')
  const [paymentLoading, setPaymentLoading] = useState(false)
  const [paymentError, setPaymentError] = useState('')
  // ----new----

  // Verification modal state
  const [showVerificationModal, setShowVerificationModal] = useState(false)
  const [remainingTime, setRemainingTime] = useState(60)
  const [canResend, setCanResend] = useState(false)

  // New state for tracking verification success
  const [verificationSuccess, setVerificationSuccess] = useState(false)

  // Load saved form data on component mount
  useEffect(() => {
    const save = () => {
      const data = latest.current
      // the “hasData” guard you already use – keep or drop as you like
      const hasData = Object.values(data).some((v) => {
        if (Array.isArray(v)) return v.length
        if (typeof v === 'boolean') return v
        if (typeof v === 'number') return v !== 1 // step starts at 1
        return v && v.toString().trim() !== ''
      })
      if (hasData) {
        localStorage.setItem('wizard-draft', JSON.stringify(data))
      }
    }

    /* page refresh / tab close */
    window.addEventListener('beforeunload', save)

    /* cleanup = componentWillUnmount */
    return () => {
      save() // route change / SPA unmount
      window.removeEventListener('beforeunload', save)
    }
  }, [])

  // Timer effect for resend countdown
  useEffect(() => {
    let timer
    if (showVerificationModal && remainingTime > 0) {
      timer = setInterval(() => {
        setRemainingTime((prev) => {
          if (prev <= 1) {
            setCanResend(true)
            return 0
          }
          return prev - 1
        })
      }, 1000)
    }
    return () => clearInterval(timer)
  }, [showVerificationModal, remainingTime])

  // Validation states (mock)
  // const isStep1Valid = wifeName && husbandName && email && phone && eventType
  // const isStep2Valid = mapLink && eventDate && eventTime
    const isStep1Valid = true // Optional fields
  const isStep2Valid = true 
  const isStep3Valid = true // Optional fields
  const isStep4Valid = true // messages – no required field
  const isStep5Valid = true // transport - optional
  // const isStep6Valid =
  //   username && password && confirmPassword && password === confirmPassword
  const isStep6Valid = true
  // Helper to go to the next or previous step
  const nextStep = () => setStep(step + 1)
  const prevStep = () => setStep(step - 1)

  /* --------------------------------------
      HANDLE REGISTRATION
  -------------------------------------- */
  const handleCouponValidation = async () => {
    setCouponLoading(true)
    setCouponError('')
    setCouponValid(false)

    try {
      const response = await axios.post(`${BASE_URL}/validate-coupon`, {
        couponCode: couponCode,
      })

      if (response.data.valid) {
        setCouponValid(true)
        setCouponError('')
      } else {
        setCouponError('Invalid coupon code')
        setCouponValid(false)
      }
    } catch (error) {
      console.error('Error validating coupon:', error)
      setCouponError('Error validating coupon. Please try again.')
      setCouponValid(false)
    } finally {
      setCouponLoading(false)
    }
  }

    // ----new----

  const generatePaymentUrl = async () => {
    setPaymentLoading(true)
    setPaymentError('')

    try {
      // Map payment method to API format
      const paymentMethodMap = {
        'Credit Card': 'credit-card',
        'PayPal': 'paypal',
        'Apple Pay': 'apple-pay',
        'Google Pay': 'google-pay'
      }

      // Generate UUID for transaction
      const generateUUID = () => {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          const r = Math.random() * 16 | 0
          const v = c === 'x' ? r : (r & 0x3 | 0x8)
          return v.toString(16)
        })
      }

      const transactionId = generateUUID()
      const fullName = `${wifeName} & ${husbandName}`

      const requestBody = {
        sale_price: 1000, // 10 shekels
        currency: 'ILS',
        product_name: 'Invitly Event Management', // You can customize this
        transaction_id: transactionId,
        sale_mobile: `+972${phone}`,
        sale_name: fullName,
        sale_payment_method: paymentMethodMap[paymentMethod] || 'credit-card',
        language: language
      }

      const response = await axios.post(
        'https://s9s9fvaofh.execute-api.il-central-1.amazonaws.com/stage/sale-generate',
        requestBody
      )

      if (response.data.status_code === 0 && response.data.sale_url) {
        setPaymentUrl(response.data.sale_url)
      } else {
        setPaymentError('Failed to generate payment URL. Please try again.')
      }
    } catch (error) {
      console.error('Error generating payment URL:', error)
      setPaymentError('Error generating payment URL. Please try again.')
    } finally {
      setPaymentLoading(false)
    }
  }

    // ----new----


  const handleCompleteRegistration = async () => {
    setLoading(true)
    setError('')

    try {
      // Parse full name into components
      const wife = wifeName.split(' ')
      const husband = husbandName.split(' ')

      // Create form data
      const formData = new FormData()
      formData.append('wife_firstname', wife[0])
      formData.append('wife_lastname', wife[1])
      formData.append('husband_firstname', husband[0])
      formData.append('husband_lastname', husband[1])
      formData.append('username', username)
      formData.append('email', email)
      formData.append('phone_number', phone)
      formData.append('event_date', eventDate)
      formData.append('event_address', mapLink)
      formData.append('password', password)
      formData.append('rsvp_text', rsvpText)
      formData.append('tomorrow_message', tomorrowMessage)
      formData.append('rsvp_second_text', rsvpTextSecond)
      formData.append('after_wedding_text', afterWeddingText)

      // Add transport data if organized
      formData.append('organize_transport', organizeTransport)
      if (organizeTransport && transportStops.length > 0) {
        formData.append('transport_stops', JSON.stringify(transportStops))
      }

      if (invitationImage) {
        formData.append('invitation', invitationImage)
      }

      const response = await axios.post(
        `${BASE_URL}/admin/register`,
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        }
      )

      if (response.status === 200) {
        // Show verification modal instead of alert
        setShowVerificationModal(true)
        setRemainingTime(60)
        setCanResend(false)
        sendCode() // Auto-send verification code
      }
    } catch (err) {
      console.error('Registration error:', err)
      
      // Parse error message from response
      let errorMessage = language === 'he' 
        ? 'ההרשמה נכשלה. אנא בדוק את הפרטים שלך.'
        : 'Registration failed. Please check your details.'
      
      if (err.response?.data) {
        const errorData = err.response.data
        const detail = errorData.msg?.detail || errorData.detail
        
        if (detail) {
          // Check for duplicate phone number
          if (detail.includes('phone_number') && detail.includes('already exists')) {
            errorMessage = language === 'he'
              ? 'מספר הטלפון הזה כבר רשום במערכת. אנא השתמש במספר טלפון אחר או התחבר לחשבון הקיים שלך.'
              : 'This phone number is already registered. Please use a different phone number or login to your existing account.'
          }
          // Check for duplicate email
          else if (detail.includes('email') && detail.includes('already exists')) {
            errorMessage = language === 'he'
              ? 'כתובת האימייל הזו כבר רשומה במערכת. אנא השתמש בכתובת אימייל אחרת או התחבר לחשבון הקיים שלך.'
              : 'This email address is already registered. Please use a different email or login to your existing account.'
          }
          // Check for duplicate username
          else if (detail.includes('username') && detail.includes('already exists')) {
            errorMessage = language === 'he'
              ? 'שם המשתמש הזה כבר תפוס. אנא בחר שם משתמש אחר.'
              : 'This username is already taken. Please choose a different username.'
          }
          // Generic duplicate key error
          else if (detail.includes('already exists')) {
            errorMessage = language === 'he'
              ? 'הפרטים שהזנת כבר קיימים במערכת. אנא בדוק את המידע שלך.'
              : 'The information you entered already exists in the system. Please check your details.'
          }
        }
        // Check for other specific error messages
        else if (errorData.error) {
          errorMessage = language === 'he'
            ? `שגיאה: ${errorData.error}`
            : `Error: ${errorData.error}`
        }
      }
      
      setError(errorMessage)
    }
    setLoading(false)
  }

  // Function to toggle password visibility
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword)
  }

  // Function to send verification code
  const sendCode = async () => {
    setRemainingTime(60)
    setCanResend(false)

    try {
      await axios.post(`${BASE_URL}/admin/send-code`, { username })
      // Silently succeed - user already sees the verification modal
    } catch (err) {
      setError('Failed to send verification code. Please try again.')
      console.error('Error sending verification code:', err)
    }
  }

  // Handle verification code submission
  const handleVerificationSubmit = async (code) => {
    try {
      const response = await axios.post(`${BASE_URL}/admin/verify-code`, {
        username,
        code,
      })

      if (response.status === 200) {
        // Set verification success to true instead of closing modal
        setVerificationSuccess(true)
      }
    } catch (err) {
      setError('Invalid verification code. Please try again.')
      console.error('Verification error:', err)
    }
  }

  // Navigate to dashboard
  const goToDashboard = () => {
    window.open('https://home.invitly.org/welcome', '_blank')
    setShowVerificationModal(false)
  }

  // Add transport stop function
  const addTransportStop = () => {
    if (newStop.trim()) {
      setTransportStops([...transportStops, newStop.trim()])
      setNewStop('')
    }
  }

  // Remove transport stop
  const removeTransportStop = (index) => {
    const updatedStops = [...transportStops]
    updatedStops.splice(index, 1)
    setTransportStops(updatedStops)
  }

  // Toggle transport organization
  const toggleTransport = (value) => {
    setOrganizeTransport(value)
    if (!value) {
      setTransportStops([])
    }
  }

  return (
    <div className="app-container">
      <Header />
   
      <div className="register-container">
          {step === 1 && (
            <div className="register-card">
              <h2>
                <T k="signUpTitle" />
              </h2>
            <p>
              <T k="signUpSubtitle" />
            </p>

            <InputWithTooltip
              label={
                language === 'he'
                  ? translations.he.wifeName
                  : translations.en.wifeName
              }
              type="text"
              placeholder={
                language === 'he'
                  ? translations.he.wifeName
                  : translations.en.wifeName
              }
              value={wifeName}
              onChange={(e) => setWifeName(e.target.value)}
              tooltip={
                language === 'he'
                  ? translations.he.wifeNameTooltip
                  : translations.en.wifeNameTooltip
              }
            />
            <InputWithTooltip
              label={
                language === 'he'
                  ? translations.he.husbandName
                  : translations.en.husbandName
              }
              type="text"
              placeholder={
                language === 'he'
                  ? translations.he.husbandName
                  : translations.en.husbandName
              }
              value={husbandName}
              onChange={(e) => setHusbandName(e.target.value)}
              tooltip={
                language === 'he'
                  ? translations.he.husbandNameTooltip
                  : translations.en.husbandNameTooltip
              }
            />

            <InputWithTooltip
              label={
                language === 'he'
                  ? translations.he.email
                  : translations.en.email
              }
              type="email"
              placeholder={
                language === 'he'
                  ? translations.he.email
                  : translations.en.email
              }
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              tooltip={
                language === 'he'
                  ? translations.he.emailTooltip
                  : translations.en.emailTooltip
              }
            />

            <InputWithTooltip
              label={
                language === 'he'
                  ? translations.he.phoneNumber
                  : translations.en.phoneNumber
              }
              type="tel"
              placeholder={
                language === 'he'
                  ? translations.he.phoneNumber
                  : translations.en.phoneNumber
              }
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              tooltip={
                language === 'he'
                  ? translations.he.phoneTooltip
                  : translations.en.phoneTooltip
              }
              prefix="+972"
            />

            <div className="input-tooltip-wrapper">
              <div className="label-tooltip">
                <select
                  value={eventType}
                  onChange={(e) => setEventType(e.target.value)}
                >
                  <option value="Wedding">
                    {language === 'he'
                      ? translations.he.wedding
                      : translations.en.wedding}
                  </option>
                  <option value="Birthday">
                    {language === 'he'
                      ? translations.he.birthday
                      : translations.en.birthday}
                  </option>
                  <option value="Other">
                    {language === 'he'
                      ? translations.he.other
                      : translations.en.other}
                  </option>
                </select>
                <div className="tooltip-container">
                  <FaInfoCircle className="info-icon" />
                  <span className="tooltip-text">
                    {language === 'he'
                      ? translations.he.eventTypeTooltip
                      : translations.en.eventTypeTooltip}
                  </span>
                </div>
              </div>
            </div>

            {/* Display error message if there is one */}
            {error && <div className="error-message">{error}</div>}

            <button
              className="next-btn"
              onClick={nextStep}
              disabled={!isStep1Valid}
            >
              <T k="nextStep" />
            </button>
          </div>     
             )}

          {step === 2 && (
          <div className="register-card">
            <h2>
              <T k="eventDetails" />
            </h2>

            <InputWithTooltip
              label={
                language === 'he'
                  ? translations.he.googleMapLink
                  : translations.en.googleMapLink
              }
              type="text"
              placeholder={
                language === 'he'
                  ? translations.he.googleMapLink
                  : translations.en.googleMapLink
              }
              value={mapLink}
              onChange={(e) => setMapLink(e.target.value)}
              tooltip={
                language === 'he'
                  ? translations.he.googleMapTooltip
                  : translations.en.googleMapTooltip
              }
            />

            <InputWithTooltip
              label={
                language === 'he'
                  ? translations.he.eventDate
                  : translations.en.eventDate
              }
              type="date"
              placeholder={
                language === 'he'
                  ? translations.he.eventDate
                  : translations.en.eventDate
              }
              value={eventDate}
              onChange={(e) => setEventDate(e.target.value)}
              tooltip={
                language === 'he'
                  ? translations.he.eventDateTooltip
                  : translations.en.eventDateTooltip
              }
              min={new Date().toISOString().split('T')[0]} // Today's date as minimum
            />

            <InputWithTooltip
              label={
                language === 'he'
                  ? translations.he.eventTime
                  : translations.en.eventTime
              }
              type="time"
              placeholder={
                language === 'he'
                  ? translations.he.eventTime
                  : translations.en.eventTime
              }
              value={eventTime}
              onChange={(e) => setEventTime(e.target.value)}
              tooltip={
                language === 'he'
                  ? translations.he.eventTimeTooltip
                  : translations.en.eventTimeTooltip
              }
            />

            <div className="input-tooltip-wrapper">
              <div className="label-tooltip">
                <label htmlFor="invitationImage" className="upload-label">
                  <FaUpload className="upload-icon" />
                  {language === 'he'
                    ? translations.he.uploadInvitation
                    : translations.en.uploadInvitation}
                </label>
                <input
                  id="invitationImage"
                  type="file"
                  accept="image/*"
                  onChange={(e) => {
                    const file = e.target.files[0]
                    if (file) {
                      console.log('Selected file:', file)
                      console.log('File size:', file.size)
                      const maxSize = 10 * 1024 * 1024 // 10MB in bytes
                      if (file.size > maxSize) {
                        setImageUploadError(
                          language === 'he' 
                            ? 'גודל הקובץ חייב להיות מתחת ל-10 מגה-בייט'
                            : 'File size must be under 10 MB'
                        )
                        e.target.value = '' // Clear the input
                        setInvitationImage(null)
                      } else {
                        setImageUploadError('') // Clear any previous errors
                        setInvitationImage(file)
                      }
                    }
                  }}
                  className="upload-input"
                />
                <div className="tooltip-container">
                  <FaInfoCircle className="info-icon" />
                  <span className="tooltip-text">
                    {language === 'he'
                      ? translations.he.uploadInvitationTooltip
                      : translations.en.uploadInvitationTooltip}
                  </span>
                </div>
              </div>
              {invitationImage && (
                <div className="file-name-display">
                  {language === 'he'
                    ? translations.he.selected
                    : translations.en.selected}
                  : {invitationImage.name}
                </div>
              )}
              {imageUploadError && (
                <div className="error-message">
                  {imageUploadError}
                </div>
              )}
            </div>

            <div className="step-nav">
              <button className="prev-btn" onClick={prevStep}>
                <T k="prevStep" />
              </button>
              <button
                className="next-btn"
                onClick={nextStep}
                disabled={!isStep2Valid}
              >
                <T k="nextStep" />
              </button>
            </div>
          </div>     
             )}
        {step === 3 && (
          <div className="register-card">
            <h2>
              <T k="customizeMessages" />
            </h2>

            <div className="message-input-container">
              <label className="input-label">
                {language === 'he'
                  ? translations.he.firstRsvpMessage
                  : translations.en.firstRsvpMessage}
              </label>
              <div className="input-tooltip-wrapper">
                <div className="label-tooltip">
                  <textarea
                    placeholder={
                      language === 'he'
                        ? 'הודעת RSVP ראשונה...'
                        : 'First RSVP SMS...'
                    }
                    value={rsvpText}
                    onChange={(e) => setRsvpText(e.target.value)}
                    aria-label={
                      language === 'he'
                        ? translations.he.firstRsvpMessage
                        : translations.en.firstRsvpMessage
                    }
                  />
                  <div className="tooltip-container">
                    <FaInfoCircle className="info-icon" />
                    <span className="tooltip-text">
                      {language === 'he'
                        ? translations.he.firstRsvpTooltip
                        : translations.en.firstRsvpTooltip}
                    </span>
                  </div>
                </div>
              </div>
            </div>


            <TextareaWithTooltip
              label={
                language === 'he'
                  ? translations.he.reminderRsvpMessage
                  : translations.en.reminderRsvpMessage
              }
              placeholder={
                language === 'he'
                  ? 'הודעת תזכורת לאורחים שלא ענו...'
                  : 'Reminder SMS for unresponsive guests...'
              }
              value={rsvpTextSecond}
              onChange={(e) => setRsvpTextSecond(e.target.value)}
              tooltip={
                language === 'he'
                  ? translations.he.reminderRsvpTooltip
                  : translations.en.reminderRsvpTooltip
              }
            />

                        <TextareaWithTooltip
              label={
                language === 'he'
                  ? translations.he.tomorrowMessage
                  : translations.en.tomorrowMessage
              }
              placeholder={
                language === 'he'
                  ? 'הודעת תזכורת יום לפני האירוע...'
                  : 'Reminder SMS the day before the event...'
              }
              value={tomorrowMessage}
              onChange={(e) => setTomorrowMessage(e.target.value)}
              tooltip={
                language === 'he'
                  ? translations.he.tomorrowTooltip
                  : translations.en.tomorrowTooltip
              }
            />

            <TextareaWithTooltip
              label={
                language === 'he'
                  ? translations.he.afterWeddingMessage
                  : translations.en.afterWeddingMessage
              }
              placeholder={
                language === 'he' ? 'הודעת תודה...' : 'Thank-you SMS...'
              }
              value={afterWeddingText}
              onChange={(e) => setAfterWeddingText(e.target.value)}
              tooltip={
                language === 'he'
                  ? translations.he.afterWeddingTooltip
                  : translations.en.afterWeddingTooltip
              }
            />

            <div className="step-nav">
              <button className="prev-btn" onClick={prevStep}>
                <T k="prevStep" />
              </button>
              <button className="next-btn" onClick={nextStep}>
                <T k="nextStep" />
              </button>
            </div>
          </div>       
           )}


        {step === 4 && (
          <div className="register-card">
            <h2>
              {language === 'he' ? 'תחבורה מאורגנת' : 'Organized Transport'}
            </h2>
            <p>
              {language === 'he'
                ? 'האם תרצה/י לארגן הסעה מאורגנת לאורחים?'
                : 'Would you like to organize transport for guests?'}
            </p>

            <div className="transport-options">
              <button
                className={organizeTransport ? 'active' : ''}
                onClick={() => toggleTransport(true)}
              >
                {language === 'he' ? 'כן' : 'Yes'}
              </button>
              <button
                className={!organizeTransport ? 'active' : ''}
                onClick={() => toggleTransport(false)}
              >
                {language === 'he' ? 'לא' : 'No'}
              </button>
            </div>

            {organizeTransport && (
              <div className="transport-stops-section">
                <p>
                  {language === 'he'
                    ? 'הוסף תחנות עצירה:'
                    : 'Add transport stops:'}
                </p>
                <div className="add-stop-container">
                  <input
                    type="text"
                    value={newStop}
                    onChange={(e) => setNewStop(e.target.value)}
                    placeholder={
                      language === 'he'
                        ? 'הקלד את שם התחנה...'
                        : 'Type stop name...'
                    }
                  />
                  <button className="add-stop-btn" onClick={addTransportStop}>
                    {language === 'he' ? 'הוסף' : 'Add'}
                  </button>
                </div>

                <ul className="stops-list">
                  {transportStops.map((stop, index) => (
                    <li key={index} className="stop-item">
                      <span>{stop}</span>
                      <button
                        className="remove-stop-btn"
                        onClick={() => removeTransportStop(index)}
                      >
                        ✕
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            <div className="step-nav">
              <button className="prev-btn" onClick={prevStep}>
                <T k="prevStep" />
              </button>
              <button
                className="next-btn"
                onClick={nextStep}
                disabled={!isStep4Valid}
              >
                <T k="nextStep" />
              </button>
            </div>
          </div>     
             )}

        {step === 5 && (
          <div className="register-card">
            <h2>
              <T k="createAccount" />
            </h2>
            <p>
              <T k="accountSetup" />
            </p>

            <InputWithTooltip
              label={
                language === 'he'
                  ? translations.he.username
                  : translations.en.username
              }
              type="text"
              placeholder={
                language === 'he'
                  ? translations.he.username
                  : translations.en.username
              }
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              tooltip={
                language === 'he'
                  ? translations.he.usernameTooltip
                  : translations.en.usernameTooltip
              }
            />

            <div className="input-tooltip-wrapper">
              <div className="label-tooltip password-field">
                <input
                  type={showPassword ? 'text' : 'password'}
                  placeholder={
                    language === 'he'
                      ? translations.he.password
                      : translations.en.password
                  }
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  aria-label={
                    language === 'he'
                      ? translations.he.password
                      : translations.en.password
                  }
                />
                <div
                  className="password-toggle"
                  onClick={togglePasswordVisibility}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </div>
                <div className="tooltip-container">
                  <FaInfoCircle className="info-icon" />
                  <span className="tooltip-text">
                    {language === 'he'
                      ? translations.he.passwordTooltip
                      : translations.en.passwordTooltip}
                  </span>
                </div>
              </div>
            </div>

            <div className="input-tooltip-wrapper">
              <div className="label-tooltip password-field">
                <input
                  type={showPassword ? 'text' : 'password'}
                  placeholder={
                    language === 'he'
                      ? translations.he.confirmPassword
                      : translations.en.confirmPassword
                  }
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  aria-label={
                    language === 'he'
                      ? translations.he.confirmPassword
                      : translations.en.confirmPassword
                  }
                />
                <div
                  className="password-toggle"
                  onClick={togglePasswordVisibility}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </div>
                <div className="tooltip-container">
                  <FaInfoCircle className="info-icon" />
                  <span className="tooltip-text">
                    {language === 'he'
                      ? translations.he.confirmPasswordTooltip
                      : translations.en.confirmPasswordTooltip}
                  </span>
                </div>
              </div>
            </div>

            {password !== confirmPassword && confirmPassword && (
              <div className="error-message">
                <T k="passwordsDoNotMatch" />
              </div>
            )}

            <div className="step-nav">
              <button className="prev-btn" onClick={prevStep}>
                <T k="prevStep" />
              </button>
              <button
                className="next-btn"
                onClick={nextStep}
                disabled={!isStep5Valid}
              >
                <T k="nextStep" />
              </button>
            </div>
          </div>       
           )}

            
        {step === 6 && (
          <div className="register-card">
            <h2>
              <T k="paymentTitle" />
            </h2>

            {/* Coupon Code Section */}
            <div className="coupon-section">
              <div className="coupon-input-container">
                <input
                  type="text"
                  placeholder={translations[language]?.couponCode || 'Coupon Code'}
                  value={couponCode}
                  onChange={(e) => {
                    setCouponCode(e.target.value)
                    setCouponValid(false) // Reset validation when code changes
                    setCouponError('')
                  }}
                  className="coupon-input"
                  aria-label={translations[language]?.couponCode || 'Coupon Code'}
                />
                <button
                  className="validate-coupon-btn"
                  onClick={handleCouponValidation}
                  disabled={!couponCode || couponLoading}
                >
                  {couponLoading ? <T k="validating" /> : <T k="validateCoupon" />}
                </button>
              </div>

              {/* Coupon Status Messages */}
              {couponError && (
                <div className="coupon-error-message">
                  {couponError}
                </div>
              )}
              {couponValid && (
                <div className="coupon-success-message">
                  <T k="couponValid" />
                </div>
              )}
            </div>

            {/* Register Button - Shown when coupon is valid */}
            {couponValid && (
              <>
                   <PayMe3DSCheckout 
        saleDetails={saleInfo}
      />


                <button
                  className="complete-btn"
                  onClick={handleCompleteRegistration}
                  disabled={loading}
                >
                  {loading ? (
                    language === 'he' ? 'רושם...' : 'Registering...'
                  ) : (
                    language === 'he' ? 'הרשמה' : 'Register'
                  )}
                </button>
                {error && <div className="error-message">{error}</div>}
              </>
            )}

             
            {/* Payment Button - Shown when coupon is not valid */}
            {!couponValid && !paymentUrl && (
              <button
                className="proceed-payment-btn"
                onClick={generatePaymentUrl}
                disabled={!paymentMethod || paymentLoading}
              >
                {paymentLoading ? (
                  language === 'he' ? 'טוען...' : 'Loading...'
                ) : (
                  language === 'he' ? 'המשך לתשלום' : 'Proceed to Payment'
                )}
              </button>
            )}

            {/* Payment Error */}
            {paymentError && (
              <div className="error-message">
                {paymentError}
              </div>
            )}

            {/* Payment Iframe */}
            {paymentUrl && (
              <div className="payment-iframe-container">
                <iframe
                  src={paymentUrl}
                  title="Secure Payment"
                  className="payment-iframe"
                  frameBorder="0"
                  allowFullScreen
                />
                <button
                  className="complete-btn"
                  onClick={handleCompleteRegistration}
                  style={{ marginTop: '20px' }}
                >
                  <T k="completeRegistration" />
                </button>
              </div>
            )}

            <div className="step-nav">
              <button className="prev-btn" onClick={prevStep}>
                <T k="prevStep" />
              </button>
            </div>
          </div>
        )}

        {/* Verification Modal */}
        {showVerificationModal && (
          <div className="modal-overlay">
            <div className="modal-content">
              {!verificationSuccess ? (
                <>
                  <h2>
                    <T k="confirmationCode" />
                  </h2>
                  <p>
                    <T k="codeSentTo" /> {phone}
                  </p>

                  {error && <div className="error-message">{error}</div>}

                  <VerificationCodeInput
                    length={6}
                    onComplete={handleVerificationSubmit}
                  />

                  <div className="resend-container">
                    {canResend ? (
                      <p>
                        <T k="didntReceiveCode" />{' '}
                        <button className="resend-link" onClick={sendCode}>
                          <T k="clickHere" />
                        </button>{' '}
                        {language === 'he' ? 'לשליחה חוזרת.' : 'to send again.'}
                      </p>
                    ) : (
                      <p>
                        <T k="resendCode" />{' '}
                        <span className="countdown">{remainingTime}</span>{' '}
                        <T k="seconds" />
                      </p>
                    )}
                  </div>

                  <button
                    className="close-modal-btn"
                    onClick={() => setShowVerificationModal(false)}
                  >
                    <T k="cancel" />
                  </button>
                </>
              ) : (
                /* Success message and dashboard link */
                <div className="success-message-container">
                  <h2>
                    <T k="registrationSuccess" />
                  </h2>
                  <p>
                    <T k="registrationSuccessMessage" />
                  </p>
                  <button
                    className="dashboard-link-btn"
                    onClick={goToDashboard}
                  >
                    <T k="goToDashboard" />
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
         
      </div>
    </div>
  )
}

export default Register
